<script lang="ts">

	export let data: {
		reason?: string; // eg. "COURIER_DELAY_CUTOFF"
		store_notification?: string; // eg "Delivery in 45 mins"
		warning_subtitle?: string; // eg "You can still fill up your cart and check out later."
		warning_title?: string; // eg "Not accepting orders right now"
	};
</script>

{#if data.warning_title || data.warning_subtitle}
	<div class="notification">
		{#if data.warning_title}
			<p class="label-xl bold">{data.warning_title}</p>
		{/if}
		{#if data.warning_subtitle}
			<p class="label-xl book">{data.warning_subtitle}</p>
		{/if}
	</div>
{/if}

<style lang="scss">
	@use 'color';
	.notification {
		background-color: color.$li-groc-note;
		padding: 1rem;
		text-align: center;
		border-radius: 20px;
		// color: color.$black; // does not work in dark mode
		p { margin: .3rem; }
	}
</style>
